export enum PriceAdjustmentOperation {
  Increase = 0,
  Decrease = 1
};
